<template>
  <div class="tpl-downloads">
    <a
      v-for="(file, index) in files"
      :key="file.format"
      :href="file.href"
      :download="file.href.split('/').pop()"
      class="tpl-download"
      :class="index === 0 ? 'tpl-download--primary' : 'tpl-download--secondary'"
      data-conversion-event="template_download"
      :data-conversion-label="`${slug}-${file.format}`"
      :data-conversion-location="location"
      translate="no"
      lang="en"
    >
      <svg aria-hidden="true" viewBox="0 0 20 20" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M10 3v10m0 0 4-4m-4 4-4-4M4 16h12" /></svg>
      <span>{{ file.label }}</span>
      <span class="tpl-download-size">{{ file.size }}</span>
    </a>
  </div>
</template>

<script setup>
// The PDF/Word buttons of a free template page. Each click sends
// `template_download` (label `<slug>-<format>`, location where it was clicked)
// through plugins/conversion-tracking.client.ts.
defineProps({
  files: { type: Array, required: true },
  slug: { type: String, required: true },
  location: { type: String, required: true },
});
</script>
